<template>
  <q-card flat bordered>
    <div
      class="q-pa-sm text-body1 text-weight-regular"
      :class="this.$q.dark.mode === true ? '' : 'text-primary '"
    >
      Signal Status
    </div>

    <div class="row q-pt-md">
      <span class="q-mx-sm text-body1 text-secondary">{{ symbol }}</span>
      <span class="q-ml-auto q-mr-sm">
        <span>Market Price :- {{ marketPrice }} </span>
        <span
          :style="{
            color: closePriceDiff > 0 ? 'green' : 'red',
          }"
        >
          ({{ closePriceDiff?.toFixed(2) }})</span
        >
      </span>
    </div>

    <div class="row justify-between">
      <div class="col-lg-12 col-12 q-mt-sm">
        <q-card flat bordered square class="q-mx-xs q-pa-sm q-pa-xs-md">
          <div class="text-subtitle2 text-secondary text-bold">
            <span v-if="weekly">Weekly Signal</span>

            <span v-else> Daily Signal </span>
          </div>
          <q-separator class="q-my-sm" />

          <div v-if="!buysell">
            <p>No Signals Found</p>
          </div>

          <div v-else>
            <div v-if="buysell.buy_date && !buysell.sell_date">
              <p>Waiting for <span class="text-red"> Red Signal</span></p>
              <p>
                Last <span class="text-green"> Green Signal</span> Generated at
                <span>{{ buysell.buy_date }}</span> @
                <span class="text-primary"> {{ buysell.buy_price }}</span>
              </p>
              <p>
                LTP Change from last signal
                <span
                  :style="{
                    color:
                      marketPrice - buysell.buy_price > 0 ? 'green' : 'red',
                  }"
                  >{{ (marketPrice - buysell.buy_price).toFixed(2) }}(
                  {{
                    (
                      ((marketPrice - buysell.buy_price) / buysell.buy_price) *
                      100
                    ).toFixed(2)
                  }}
                  %)
                </span>
              </p>

              <q-separator />

              <div class="q-mt-sm" v-if="buysell">
                <p v-if="buysell.profit_target">
                  Profit Target : {{ buysell.profit_target?.toFixed(2) }}
                  <span
                    :style="{
                      color:
                        buysell.profit_target - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >({{
                      (
                        ((buysell.profit_target - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}
                    %)
                  </span>
                </p>
                <p v-if="buysell.profit_target1">
                  Profit Target 1 :
                  {{ buysell.profit_target1?.toFixed(2) }}
                  <span
                    :style="{
                      color:
                        buysell.profit_target1 - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >({{
                      (
                        ((buysell.profit_target1 - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}
                    %)
                  </span>
                </p>
                <p v-if="buysell.profit_target2">
                  Profit Target 2 :
                  {{ buysell.profit_target2?.toFixed(2) }}
                  <span
                    :style="{
                      color:
                        buysell.profit_target2 - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >({{
                      (
                        ((buysell.profit_target2 - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}
                    %)
                  </span>
                </p>
              </div>
              <q-separator />

              <div class="q-mt-sm">
                <p>
                  Stop Loss :{{ buysell.stop_loss?.toFixed(2) }}
                  <span
                    :style="{
                      color:
                        buysell.stop_loss - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >({{
                      (
                        ((buysell.stop_loss - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}
                    %)
                  </span>
                </p>
              </div>

              <div>
                <p>
                  Trailing Stop Loss :{{
                    buysell.trailing_stop_loss?.toFixed(2)
                  }}
                  <span
                    :style="{
                      color:
                        buysell.trailing_stop_loss - buysell.buy_price > 0
                          ? 'green'
                          : 'red',
                    }"
                    >({{
                      (
                        ((buysell.trailing_stop_loss - buysell.buy_price) /
                          buysell.buy_price) *
                        100
                      )?.toFixed(2)
                    }}
                    %)
                  </span>
                </p>
              </div>
            </div>

            <div v-else-if="buysell.buy_date && buysell.sell_date">
              <p>Waiting for<span class="text-green"> Green Signal</span></p>

              <p>
                Last <span class="text-red"> Red Signal</span> Generated at
                <span>{{ buysell.sell_date }}</span> @
                <span class="text-primary"> {{ buysell.sell_price }}</span>
              </p>
              <p>
                LTP Change from last signal

                <span
                  :style="{
                    color:
                      marketPrice - buysell.sell_price > 0 ? 'green' : 'red',
                  }"
                  >{{ (marketPrice - buysell.sell_price)?.toFixed(2) }} (
                  {{
                    (
                      ((marketPrice - buysell.sell_price) /
                        buysell.sell_price) *
                      100
                    ).toFixed(2)
                  }}
                  %)
                </span>
              </p>
            </div>
          </div>

          <div v-if="buyTarget || sellTarget">
            <q-separator class="q-mb-md" />
            <div class="text-body2 text-secondary text-bold">
              Your Buy Sell Target
            </div>
            <q-separator class="q-my-sm" />

            <div class="row q-pt-xs">
              <p>Buy Target</p>
              <p v-if="buyTarget" class="q-ml-auto q-mr-md">{{ buyTarget }}</p>
              <p v-else class="q-ml-auto q-mr-md">-</p>
            </div>

            <div class="row">
              <p>Sell Target</p>
              <p v-if="sellTarget" class="q-ml-auto q-mr-md">
                {{ sellTarget }}
              </p>
              <p v-else class="q-ml-auto q-mr-md">-</p>
            </div>
          </div>
        </q-card>
      </div>
    </div>

    <DisclaimerMessage extended />
  </q-card>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import useCore from "src/use/core";
import useData from "src/use/data";
import useMembership from "src/use/membership";
import DisclaimerMessage from "src/components/DisclaimerMessage.vue";

export default {
  name: "StockWiseSignalStatus",
  components: { DisclaimerMessage },
  props: {
    symbol: {
      type: String,
      required: true,
    },
    weekly: {
      type: Boolean,
    },
    intraday: {
      type: Boolean,
    },
  },
  setup(props) {
    const {
      historyDataSearch,
      buySellSearch,
      buySellSearchWeekly,
      trailingStopLossBuySell,
    } = useData();

    const { getMySignalswithTarget } = useMembership();

    const buysell = ref([]);
    const marketPrice = ref([]);
    const closePriceDiff = ref(null);

    const signalsWithTarget = ref([]);
    const buyTarget = ref(null);
    const sellTarget = ref(null);

    const getSignal = () => {
      getMySignalswithTarget().then((res) => {
        signalsWithTarget.value = res.data;

        buyTarget.value = signalsWithTarget.value?.filter(
          (item) => item.symbol === props.symbol
        )[0]?.buy_target;

        sellTarget.value = signalsWithTarget.value?.filter(
          (item) => item.symbol === props.symbol
        )[0]?.sell_target;
      });

      if (props.weekly) {
        buySellSearchWeekly(props.symbol)
          .then((res) => {
            buysell.value = res.data[0];

            trailingStopLossBuySell(props.symbol)
              .then((res) => {
                if (res.data.length)
                  buysell.value["trailing_stop_loss"] =
                    res.data[0].trailing_stop_loss;
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (props.intraday) {
      } else {
        buySellSearch(props.symbol)
          .then((res) => {
            buysell.value = res.data[0];
            trailingStopLossBuySell(props.symbol)
              .then((res) => {
                if (res.data.length)
                  buysell.value["trailing_stop_loss"] =
                    res.data[0].trailing_stop_loss;
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }

      historyDataSearch(props.symbol)
        .then((res) => {
          marketPrice.value = res.data[0].close;
          closePriceDiff.value = res.data[0].close - res.data[1].close;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    onMounted(() => {
      getSignal(props.symbol);
    });

    watch(props, (newProps, oldProps) => {
      getSignal(newProps.symbol);
    });

    return {
      marketPrice,
      buysell,
      closePriceDiff,
      buyTarget,
      sellTarget,
    };
  },
};
</script>
